var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNature(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_28450_2004",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_28450_2004)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.25 20.0578V15.6923H9C7.75133 15.6923 6.68917 15.2544 5.8135 14.3788C4.93783 13.5033 4.5 12.4411 4.5 11.1923C4.5 10.2499 4.78142 9.39801 5.34425 8.63651C5.90708 7.87501 6.6295 7.30901 7.5115 6.93851C7.65517 5.65651 8.14492 4.62834 8.98075 3.85401C9.81675 3.07951 10.8232 2.69226 12 2.69226C13.1768 2.69226 14.1833 3.07951 15.0193 3.85401C15.8551 4.62834 16.3448 5.65651 16.4885 6.93851C17.3768 7.29618 18.1008 7.85901 18.6605 8.62701C19.2202 9.39484 19.5 10.2499 19.5 11.1923C19.5 12.4411 19.0622 13.5033 18.1865 14.3788C17.3108 15.2544 16.2487 15.6923 15 15.6923H12.75V20.0578H17.75C17.9625 20.0578 18.1406 20.1297 18.2843 20.2735C18.4281 20.4173 18.5 20.5955 18.5 20.808C18.5 21.0207 18.4281 21.1988 18.2843 21.3423C18.1406 21.4859 17.9625 21.5578 17.75 21.5578H6.25C6.0375 21.5578 5.85942 21.4858 5.71575 21.342C5.57192 21.1982 5.5 21.0199 5.5 20.8073C5.5 20.5948 5.57192 20.4167 5.71575 20.273C5.85942 20.1295 6.0375 20.0578 6.25 20.0578H11.25ZM9 14.1923H15C15.8333 14.1923 16.5417 13.9006 17.125 13.3173C17.7083 12.7339 18 12.0256 18 11.1923C18 10.5474 17.8019 9.97018 17.4057 9.46051C17.0096 8.95101 16.5077 8.57318 15.9 8.32701L15.1 7.99226L14.9885 7.09226C14.882 6.19493 14.5544 5.48726 14.0057 4.96926C13.4571 4.45126 12.7885 4.19226 12 4.19226C11.2115 4.19226 10.5429 4.45126 9.99425 4.96926C9.44558 5.48726 9.118 6.19493 9.0115 7.09226L8.9 7.99226L8.023 8.36551C7.441 8.61168 6.95833 8.98634 6.575 9.48951C6.19167 9.99268 6 10.5603 6 11.1923C6 12.0256 6.29167 12.7339 6.875 13.3173C7.45833 13.9006 8.16667 14.1923 9 14.1923Z",
    fill: "#395966"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNature);
export default __webpack_public_path__ + "static/media/nature.74c7cebc8421f034402e20d50bece9a7.svg";
export { ForwardRef as ReactComponent };